export default __webpack_public_path__ + "static/media/spotify_podcast.ec70ec36.svg";